<template>
    <div>
        <crud-table
            ref="table"

            api="portal_todo_templates"

            label="Portal-Aufgaben"
            :name="{singular: 'Portal-Aufgabe', plural: 'Portal-Aufgaben'}"

            v-on:add="openForm"
            v-on:edit="openForm"
            @dataLoaded="data => $store.commit('updateData', {portalTodoTemplates: data})"

            :filter="params"

            :columns="columns"
        >
            <h2 slot="header">Vordefinierte Aufgaben</h2>

            <template v-slot:dueDateMode="slotProps">
                {{ dueLabel(slotProps.row) }}
            </template>

            <template v-slot:autoAssignToCreator="slotProps">
                {{ slotProps.row.autoAssignToCreator ? 'Ersteller' : 'niemand' }}
            </template>

            <template v-slot:active="slotProps">
                <i v-if="slotProps.row.active" class="material-icons">check</i>
            </template>

            <todo-template-form
                slot="form"
                formType="modal"
                ref="form"
                v-on:success="$refs.table.refresh()"
            />

            <template v-slot:footer>
                <div class="level level-left">
                    <a
                        v-on:click="openForm"
                        class="button level-item is-primary"
                    >Aufgabe hinzufügen</a>
                </div>
            </template>
        </crud-table>
    </div>
</template>

<script>
import Mixin from '../tab';
import TodoTemplateForm from './TodoTemplateForm';
import { CrudTable } from '@components/CRUD';
import { portalTodoDueLabel } from './options';

/**
 * Predefined ClientPortal tasks of this client — the portal counterpart of the
 * provider/agency "Automatische Aufgaben für Reisen" tab. Same CrudTable shape as
 * the Portal-Felder section right above it, so both read as one settings page.
 */
export default {
    mixins: [Mixin],

    data: function () {
        return {
            columns: [
                { key: 'name', label: 'Aufgabe', class: 'has-border is-pure-text is-ellipsis', style: 'flex-grow:1;flex-shrink:1', formElement: 'PureText' },
                { key: 'dueDateMode', label: 'Fälligkeit', class: 'has-border is-200px-cell is-pure-text is-ellipsis', style: 'flex-grow:1;flex-shrink:1', sortable: false },
                { key: 'autoAssignToCreator', label: 'Zuständig', class: 'has-border is-110px-cell is-pure-text is-ellipsis', style: 'flex-grow:1;flex-shrink:1', sortable: false },
                { key: 'sortOrder', label: 'Reihenfolge', class: 'has-border is-90px-cell is-pure-text has-text-centered', style: 'flex-grow:1;flex-shrink:1', formElement: 'PureText' },
                { key: 'active', label: 'Aktiv', class: 'has-border is-icon-cell is-ellipsis has-text-centered', style: 'flex-grow:1;flex-shrink:1', sortable: false },
            ],
        };
    },

    computed: {
        params() {
            return {
                'client.id': this.item.id,
                '_order[sortOrder]': 'ASC',
            };
        },
    },

    methods: {
        dueLabel: portalTodoDueLabel,
    },

    activated: function () {
        this.$refs.table.refresh();
    },

    components: {
        CrudTable,
        TodoTemplateForm,
    },
};
</script>
